import {
    BROWSER_CHECKS,
    BROWSER_TYPES,
    OS_MAP,
    OS_TYPES,
} from '../services/client-device-marker/device-detection.constants';

export function getOS(): string {
    const userAgent = navigator.userAgent;
    for (const [os, regex] of Object.entries(OS_MAP)) {
        if (regex.test(userAgent)) return os;
    }
    return OS_TYPES.UNKNOWN;
}

export function getBrowser(): string {
    for (const [browser, checkFn] of Object.entries(BROWSER_CHECKS)) {
        if (checkFn()) return browser;
    }
    return BROWSER_TYPES.UNKNOWN;
}
